import { getState, saveState, compareValues } from './storage.js';
import { initDataGridInstance, abortDataGridLifetime } from './create-instance.js';
import { collapseOpenItems } from './collapse-items.js';
import { getSortValueFromRow } from './sort-value.js';
import { createToggleRowHelpers } from './mobile-expand.js';

function init(grid, options) {
    initDataGridInstance(grid, options);
}

function showItemByRowId(gridEl, rowId) {
    if (gridEl && typeof gridEl.showItemByRowId === 'function') {
        return gridEl.showItemByRowId(rowId);
    }
    return false;
}

const DataGrid = {
    init,
    abortDataGridLifetime,
    getState,
    saveState,
    compareValues,
    getSortValueFromRow,
    collapseOpenItems,
    get toggleOpenItemById() {
        return createToggleRowHelpers(collapseOpenItems);
    },
    showItemByRowId,
};

export {
    init,
    abortDataGridLifetime,
    getState,
    saveState,
    compareValues,
    getSortValueFromRow,
    collapseOpenItems,
    showItemByRowId,
};

export default DataGrid;
